import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './FocusFooter.scss';

const FocusFooter = ({ children, className = '' }) => (
    <Stack className={getClassName(styles['footer-stack'], className)}>
        {children}
    </Stack>
);

export default FocusFooter;
